import { jsx as e, Fragment as l, jsxs as f } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { S } from "./index-DoOsnuB6.js";
import { c as z } from "./index-BNmRGtA6.js";
import { c as x } from "./clsx-OuTLNxxd.js";
import { S as y } from "./Spinner-Drz3dWpe.js";
import './Button.css';const h = "_button_m82fi_38", g = "_xxSmallSize_m82fi_114", p = "_xSmallSize_m82fi_122", b = "_smallSize_m82fi_130", B = "_defaultSize_m82fi_138", v = "_largeSize_m82fi_144", F = "_iconSize_m82fi_152", W = "_primary_m82fi_161", j = "_secondary_m82fi_170", C = "_tertiary_m82fi_183", N = "_active_m82fi_197", V = "_ghost_m82fi_202", k = "_ghostBrand_m82fi_203", w = "_outline_m82fi_243", R = "_surface_m82fi_255", q = "_isFullWidth_m82fi_261", A = "_rounded_m82fi_265", t = {
  button: h,
  xxSmallSize: g,
  xSmallSize: p,
  smallSize: b,
  defaultSize: B,
  largeSize: v,
  iconSize: F,
  primary: W,
  secondary: j,
  tertiary: C,
  active: N,
  ghost: V,
  ghostBrand: k,
  outline: w,
  surface: R,
  isFullWidth: q,
  rounded: A
}, D = z(t.button, {
  variants: {
    variant: {
      default: t.primary,
      ghost: t.ghost,
      ghostBrand: t.ghostBrand,
      secondary: t.secondary,
      tertiary: t.tertiary,
      active: t.active,
      outline: t.outline,
      surface: t.surface
    },
    size: {
      "xx-small": t.xxSmallSize,
      "x-small": t.xSmallSize,
      small: t.smallSize,
      default: t.defaultSize,
      large: t.largeSize,
      icon: t.iconSize
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), E = c(
  ({ asChild: r, isLoading: i, loadingText: o, variant: a, ...s }, n) => /* @__PURE__ */ e(l, { children: i ? /* @__PURE__ */ e(m, { ...s, "aria-busy": i, disabled: i, ref: n, variant: a, children: /* @__PURE__ */ f(l, { children: [
    o || "Loading",
    /* @__PURE__ */ e(y, { size: "s", variant: a === "secondary" ? "dark" : "light" })
  ] }) }) : /* @__PURE__ */ e(m, { ...s, asChild: r, ref: n, variant: a }) })
), m = c(
  ({ asChild: r = !1, className: i, disabled: o, isFullWidth: a, rounded: s, size: n, variant: _, ...d }, u) => /* @__PURE__ */ e(
    r ? S : "button",
    {
      className: x(
        D({ variant: _, size: n }),
        { [t.isFullWidth]: a, [t.rounded]: s },
        i
      ),
      "data-cxy-name": "button",
      "data-testid": "button-component",
      disabled: o,
      ref: u,
      ...d
    }
  )
);
E.displayName = "Button";
export {
  E as B,
  D as b
};
